// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"2c5d9b1a","338":"e5bdc0dd","355":"af30b4cf","399":"2fc75d67","448":"8b5c38b8","567":"8927d452","625":"0ecdef73","644":"82838f54","741":"a1e55b4f","764":"6d0fdcdc","804":"6dee4187"}[chunkId] + ".chunk.js";
};